export const MENU_OPEN = 'Menu.Open';
export const MENU_CLOSE = 'Menu.Close';

export function closeMenu() {
    return {
        type: MENU_CLOSE
    };
}

export function openMenu() {
    return {
        type: MENU_OPEN
    };
}
